import { Point } from '../../type/common.interface';

export function getFuncParabola(x: number, point1: Point, point2: Point, point3: Point): number {
    const x1 = point1.x;
    const y1 = point1.y;
    const x2 = point2.x;
    const y2 = point2.y;
    const x3 = point3.x;
    const y3 = point3.y;

    // 构建矩阵
    const matrix = [
        [x1 * x1, x1, 1, y1],
        [x2 * x2, x2, 1, y2],
        [x3 * x3, x3, 1, y3],
    ];

    // 使用高斯消元法求解
    for (let i = 0; i < 3; i++) {
        // 找到主元
        let maxRow = i;
        for (let k = i + 1; k < 3; k++) {
            if (Math.abs(matrix[k][i]) > Math.abs(matrix[maxRow][i])) {
                maxRow = k;
            }
        }

        // 交换行
        [matrix[i], matrix[maxRow]] = [matrix[maxRow], matrix[i]];

        // 消元
        for (let k = i + 1; k < 3; k++) {
            const factor = matrix[k][i] / matrix[i][i];
            for (let j = i; j <= 3; j++) {
                matrix[k][j] -= factor * matrix[i][j];
            }
        }
    }

    // 回代求解
    const c = matrix[2][3] / matrix[2][2];
    const b = (matrix[1][3] - (matrix[1][2] * c)) / matrix[1][1];
    const a = (matrix[0][3] - (matrix[0][2] * c) - (matrix[0][1] * b)) / matrix[0][0];

    return (a * (x ** 2)) + (b * x) + c;
}
